<template>
  <div class="card" id="empty-form">
    <p>¡Inicia tu formulario!</p>

    <a-button type="link" class="button" @click="emit('open')" id="open-form-items-drawer">
      <PlusOutlined />
      Agrega un elemento para iniciar con tu formulario
    </a-button>
  </div>
</template>

<script setup lang="ts">
import { PlusOutlined } from "@ant-design/icons-vue";

const emit = defineEmits<{
  (e: "open"): void;
}>();
</script>

<style scoped lang="sass">
.card
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  margin: 20px 30px
  border: 1px dotted $blue-5
  border-radius: 4px
  padding: 30px 0

p
  color: $gray-8
</style>
